// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__xxhT9","calendarButtons":"ClockData_calendarButtons__2eg3G"};